import React from "react";

const TableLoader = () => (
  <div className="flex flex-1 w-full items-center justify-center py-12">
    <div className="w-6 h-6 border-2 border-gray-300 border-t-primary-blue rounded-full animate-spin" />
  </div>
);

export default TableLoader;
